import Certificate from './Certificate.vue';

export default Certificate;



// WEBPACK FOOTER //
// ./src/pages/profile/views/certificate/index.ts